export default __webpack_public_path__ + "static/media/rating_web-sm@2x.34ee4aeb.jpg";